import React from 'react';
import Layout from '../components/layout';
import Hero from '../components/hero'
import ContactForm from '../components/forms/contact';
export default () => (
  <Layout>
    <Hero
      content={
        <h2 className="title" style={{ textTransform: 'lowercase' }}>
          Contact.
          </h2>
      }
      additionalClasses="is-medium"
    />

<section className="section">
    <div className="container">
      <div className="columns">
        <div className="column is-two-thirds">
          <p>
            We would love to hear from you -
            please contact us using the form below if you are wanting to a view a property or have a general query - we aim to respond within 24 hours
          </p>
          <ContactForm />
        </div>
      </div>
    </div >
    </section>

  </Layout >
);
